import { request } from '../api';
import { GetSearchData } from './search.types';

const SEARCH_QUERY = 'search';

export const getSearchData: GetSearchData = async ({ token, ...params }) =>
  await request({
    query: SEARCH_QUERY,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
  });
